export default {
    namespaced: true,
    state: {
        data: {},
        loading: false
    },
    mutations: {
        SET_TIMEZONES_DATA: (state, payload) => state.data = payload,
        LOADING_PROCESS: state => (state.loading = true),
        LOADING_COMPLETED: state => (state.loading = false),
        REMOVE_ERROR: state => (state.error = false),
    },
    actions: {
        getTimeZonesData: ({state, commit}) => {
            commit("LOADING_PROCESS")
            commit("REMOVE_ERROR")
            return axios({url: '/info/time-zones-settings', method: 'GET' })
                .then(resp => {
                    commit('SET_TIMEZONES_DATA', resp.data)
                    commit("LOADING_COMPLETED")
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                    console.log(err)
                })
        },
        updateTimeZonesData: ({state, commit}, data) => {
            commit("LOADING_PROCESS")
            commit("REMOVE_ERROR")
            return axios({url: '/info/time-zones-settings', data: {form: data}, method: 'POST' })
                .then(resp => {
                    commit('SET_TIMEZONES_DATA', resp.data)
                    commit("LOADING_COMPLETED")
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                    console.log(err)
                })
        }
    },
    getters: {
        TIMEZONES_DATA: state => state.data,
    }
}
